import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.DOCUMENTS,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.DOCUMENTS}/${id}`,
    method: "get",
  });
}

async function create(data) {
  return await request({
    url: ENDPOINT.DOCUMENTS,
    method: "post",
    data,
  });
}

async function update(data) {
  return await request({
    url: `${ENDPOINT.DOCUMENTS}/${data.id}`,
    method: "patch",
    data,
  });
}

async function updateMultiple(data) {
  return await request({
    url: `${ENDPOINT.DOCUMENTS}`,
    method: "patch",
    data,
  });
}

async function remove(data) {
  return await request({
    url: `${ENDPOINT.DOCUMENTS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  updateMultiple,
  remove,
};
